import React from 'react';
import styled from '@emotion/styled';

import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { SCREEN_BREAKPOINTS } from '../../constants';

const QUOTE_DATA = {
  blockquote: `"I'm really excited to tap into the Spotify Audience Network as an Anchor creator. Anchor's been an amazing platform, and has helped my podcast grow to where it is now. I have full confidence that their monetization tools will continue to help creators like me expand our businesses further."`,
  cite: `Creator of rSlash`,
};

const QuoteFigure = styled.figure`
  width: 100%;
  max-width: 968px;
  margin: 0 auto 48px;
  color: ${COLOR_GREEN};
`;

const QuoteBlockquote = styled.blockquote`
  margin: 0 0 24px;
  padding: 0 24px;
  border: none;
  font-weight: 900;
  font-size: 3.5rem;
  line-height: 4rem;
  text-align: center;
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    font-size: 2rem;
    line-height: 3rem;
  }
`;

const QuoteFigcaption = styled.figcaption`
  font-size: 2rem;
  line-height: 3rem;
  text-align: center;
`;

export const Blockquote = () => {
  return (
    <QuoteFigure>
      <QuoteBlockquote>{QUOTE_DATA.blockquote}</QuoteBlockquote>
      <QuoteFigcaption>
        <cite>{QUOTE_DATA.cite}</cite>
      </QuoteFigcaption>
    </QuoteFigure>
  );
};
